var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.548 12.3752C15.5224 9.60612 17.8734 8.25897 17.9809 8.19625C16.6495 6.30353 14.5857 6.04492 13.8605 6.0243C12.1272 5.84645 10.4459 7.03553 9.56298 7.03553C8.66241 7.03553 7.30274 6.04148 5.83732 6.07069C3.95158 6.09905 2.18745 7.16354 1.21991 8.81656C-0.77686 12.187 0.712345 17.1401 2.6254 19.8645C3.58237 21.1987 4.70059 22.6885 6.16424 22.6361C7.59617 22.5785 8.13105 21.746 9.85906 21.746C11.5712 21.746 12.0735 22.6361 13.5662 22.6026C15.103 22.5785 16.0705 21.2623 16.994 19.916C18.0999 18.3867 18.544 16.8806 18.5617 16.8033C18.5255 16.7913 15.5771 15.6941 15.548 12.3752Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7282 4.2321C13.4984 3.29304 14.0253 2.01548 13.879 0.719009C12.7643 0.767122 11.3703 1.47077 10.5675 2.38921C9.85729 3.19853 9.22284 4.52507 9.38674 5.77257C10.6389 5.86364 11.9246 5.15655 12.7282 4.2321Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.85aef45f02892f694748b629a6b6348b.svg";
export { ForwardRef as ReactComponent };